<etoh-page-form
  [dataTabs]="dataTabs"
  [name]="'Contact'"
  [id]="id"
  [title]="title"
  [standalone]="standalone"
  [dataType]="'contacts'"
  [fields]="fields"
  (loaded)="onLoaded()"
  [options]="options"
  [model]="model"
  [shouldPrevent]="shouldPrevent"
  [headerButtons]="headerButtons"
></etoh-page-form>
